import React, { useState } from "react";
import imageCompression from "browser-image-compression";
import img from "../assets/Spinner-3.gif";
import Swal from "sweetalert2";

function formatFileSize(bytes) {
    if (typeof bytes !== "number") return "";
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

function FileField({ label, hint, file, error, name, accept = ".png, .jpg", onChange, disabled }) {
    const hasFile = Boolean(file);
    return (
        <div className="file-field">
            <label htmlFor={name} className="form-label">{label}</label>
            {hint && <span className="file-hint">{hint}</span>}
            <input
                type="file"
                id={name}
                className={`inputtype form-control mb-2${error ? " is-invalid" : ""}`}
                onChange={onChange}
                accept={accept}
                name={name}
                disabled={disabled}
            />
            {hasFile ? (
                <div className="file-chip file-chip-selected">
                    <span className="file-chip-icon">✓</span>
                    <span className="file-chip-name">{file.name}</span>
                    <span className="file-chip-size">{formatFileSize(file.size)}</span>
                </div>
            ) : (
                <div className="file-chip file-chip-empty">No file selected</div>
            )}
            {error && <div className="text-danger">{error}</div>}
        </div>
    );
}

function BgcForm() {
    const [isLoading, setIsLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    // Tracks in-flight image compression so Submit can't run against
    // stale (pre-compression) file state and wrongly report a file as missing.
    const [pendingUploads, setPendingUploads] = useState(0);

    const [isSameAddressChecked, setIsSameAddressChecked] = useState(false);

    /* personal details */
    const [name, setName] = useState("");
    const [fname, setFname] = useState("");
    const [mname, setMname] = useState("");
    const [gender, setGender] = useState("");
    const [date, setDate] = useState("");
    const [email, setEmail] = useState("");
    const [number, setNumber] = useState("");
    const [enumber, setEnumber] = useState("");
    const [companyname, setCompanyName] = useState("");
    const [location, setLocation] = useState("");
    const [language, setLanguage] = useState("");
    const [blood, setBlood] = useState("");

    const [address1, setAddress1] = useState("");
    const [address2, setAddress2] = useState("");
    const [address3, setAddress3] = useState("");
    const [post, setPost] = useState("");
    const [police, setPolice] = useState("");
    const [district, setDistrict] = useState("");
    const [tehsil, setTehsil] = useState("");
    const [landmark, setLandmark] = useState("");
    const [pincode, setPincode] = useState("");
    const [state, setState] = useState("");

    const [address11, setAddress11] = useState("");
    const [address22, setAddress22] = useState("");
    const [address33, setAddress33] = useState("");
    const [post1, setPost1] = useState("");
    const [police1, setPolice1] = useState("");
    const [district1, setDistrict1] = useState("");
    const [tehsil1, setTehsil1] = useState("");
    const [landmark1, setLandmark1] = useState("");
    const [pincode1, setPincode1] = useState("");
    const [state1, setState1] = useState("");

    const [aadhar_front_side, setAadhar_Front_Side] = useState("");
    const [aadhar_back_side, setAadhar_Back_Side] = useState("");
    const [passport_size_photo, setPassport_Size_Photo] = useState("");

    const [referenceId, setReferenceId] = useState("");
    const [errors, setErrors] = useState({});

    const handleFileChange = async (event, setStateFunction) => {
        const file = event.target.files[0];
        if (file) {
            setPendingUploads((count) => count + 1);
            try {
                const fileType = file.type;

                if (
                    fileType === "application/pdf" ||
                    fileType === "image/jpeg" ||
                    fileType === "image/png" ||
                    fileType === "image/jpg"
                ) {
                    if (fileType === "application/pdf") {
                        setStateFunction(file);
                    } else {
                        const options = {
                            maxSizeMB: 0.2,
                            maxWidthOrHeight: 1920,
                            useWebWorker: true,
                        };

                        const compressedFile = await imageCompression(file, options);
                        setStateFunction(compressedFile);
                    }
                } else {
                    console.error(
                        "Unsupported file format. Please upload a PDF, JPG, JPEG, or PNG file."
                    );
                }
            } catch (error) {
                console.error("Error processing file:", error);
            } finally {
                setPendingUploads((count) => count - 1);
            }
        }
    };

    const billingFunction = () => {
        setIsSameAddressChecked((prevValue) => !prevValue);
        if (isSameAddressChecked) {
            setAddress11("");
            setAddress22("");
            setAddress33("");
            setPost1("");
            setPolice1("");
            setDistrict1("");
            setTehsil1("");
            setLandmark1("");
            setPincode1("");
            setState1("");
        } else {
            setAddress11(address1);
            setAddress22(address2);
            setAddress33(address3);
            setPost1(post);
            setPolice1(police);
            setDistrict1(district);
            setTehsil1(tehsil);
            setLandmark1(landmark);
            setPincode1(pincode);
            setState1(state);
        }
    };

    const BgcFormSubmit = async () => {
        setIsLoading(true);
        const formData = new FormData();

        formData.append("full_name", name);
        formData.append("fathers_name", fname);
        formData.append("mothers_name", mname);
        formData.append("gender", gender);
        formData.append("dob", date);
        formData.append("email", email);
        formData.append("contact_number", number);
        formData.append("emergency_number", enumber);
        formData.append("name_of_the_client", companyname);
        formData.append("client_location", location);
        formData.append("language_known", language);
        formData.append("blood_group", blood);

        formData.append("permanent_village_city", address1);
        formData.append("permanent_village_city2", address2);
        formData.append("permanent_village_city3", address3);
        formData.append("permanent_post_office", post);
        formData.append("permanent_police_station", police);
        formData.append("permanent_district", district);
        formData.append("permanent_tehsil", tehsil);
        formData.append("permanent_landmark", landmark);
        formData.append("permanent_pincode", pincode);
        formData.append("permanent_state", state);

        formData.append("current_village_city", address11);
        formData.append("current_village_city2", address22);
        formData.append("current_village_city3", address33);
        formData.append("current_post_office", post1);
        formData.append("current_police_station", police1);
        formData.append("current_district", district1);
        formData.append("current_tehsil", tehsil1);
        formData.append("current_landmark", landmark1);
        formData.append("current_pincode", pincode1);
        formData.append("current_state", state1);

        formData.append("adhar_frontside", aadhar_front_side);
        formData.append("adhar_backside", aadhar_back_side);
        formData.append("photo", passport_size_photo);

        try {
            let response = await fetch(
                "https://humhai.in/background-verification/featured-form/",
                {
                    method: "POST",
                    body: formData,
                }
            );

            let data = await response.json();
            setReferenceId(data.reference_id);

            if (data.status === 200) {
                setSuccess(true);
            } else {
                Swal.fire({
                    icon: "error",
                    title: data.message || "Failed to submit data",
                });
            }
        } catch (error) {
            Swal.fire({
                icon: "error",
                title: error.message || "Failed to submit data",
            });
        } finally {
            setIsLoading(false);
        }
    };

    const handleSubmit = () => {
        if (pendingUploads > 0) {
            alert("Please wait for the file uploads to finish processing.");
            return;
        }

        const newErrors = {};
        if (!name) newErrors.name = "Name is required.";
        if (!fname) newErrors.fname = "Father's/Husband's/Wife's name is required.";
        if (!mname) newErrors.mname = "Mother's name is required.";
        if (!gender) newErrors.gender = "Please choose a gender.";
        if (!date) newErrors.date = "Date of birth is required.";
        if (!email) {
            newErrors.email = "Email is required.";
        } else {
            const emailR =
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!emailR.test(email)) newErrors.email = "Please enter a valid email address.";
        }
        if (!number) newErrors.number = "Contact number is required.";
        if (!enumber) newErrors.enumber = "Emergency contact number is required.";
        if (!companyname) newErrors.companyname = "Company name is required.";
        if (!location) newErrors.location = "Company location is required.";

        if (!address1) newErrors.address1 = "Address line 1 is required.";
        if (!post) newErrors.post = "Post office is required.";
        if (!police) newErrors.police = "Police station is required.";
        if (!district) newErrors.district = "District is required.";
        if (!tehsil) newErrors.tehsil = "Tehsil is required.";
        if (!landmark) newErrors.landmark = "Landmark is required.";
        if (!pincode) newErrors.pincode = "Pin code is required.";
        if (!state) newErrors.state = "State is required.";

        if (!address11) newErrors.address11 = "Address line 1 is required.";
        if (!post1) newErrors.post1 = "Post office is required.";
        if (!police1) newErrors.police1 = "Police station is required.";
        if (!district1) newErrors.district1 = "District is required.";
        if (!tehsil1) newErrors.tehsil1 = "Tehsil is required.";
        if (!landmark1) newErrors.landmark1 = "Landmark is required.";
        if (!pincode1) newErrors.pincode1 = "Pin code is required.";
        if (!state1) newErrors.state1 = "State is required.";

        if (!aadhar_front_side) newErrors.aadhar_front_side = "Aadhar card front side is required.";
        if (!aadhar_back_side) newErrors.aadhar_back_side = "Aadhar card back side is required.";
        if (!passport_size_photo) newErrors.passport_size_photo = "Passport size photo is required.";

        setErrors(newErrors);
        if (Object.keys(newErrors).length === 0) {
            BgcFormSubmit();
        }
    };

    const resetForm = () => {
        setSuccess(false);
        setIsSameAddressChecked(false);

        setName("");
        setFname("");
        setMname("");
        setGender("");
        setDate("");
        setEmail("");
        setNumber("");
        setEnumber("");
        setLocation("");
        setLanguage("");
        setBlood("");

        setAddress1("");
        setAddress2("");
        setAddress3("");
        setPost("");
        setPolice("");
        setDistrict("");
        setTehsil("");
        setLandmark("");
        setPincode("");
        setState("");

        setAddress11("");
        setAddress22("");
        setAddress33("");
        setPost1("");
        setPolice1("");
        setDistrict1("");
        setTehsil1("");
        setLandmark1("");
        setPincode1("");
        setState1("");

        setAadhar_Front_Side("");
        setAadhar_Back_Side("");
        setPassport_Size_Photo("");
        setErrors({});
    };

    return (
        <div className="form-container">
            {success ? (
                <div className="success-screen text-center">
                    <div className="success-icon">✓</div>
                    <h2 className="success-title">Application Submitted Successfully</h2>

                    <p className="success-message">
                        Thank you! Your background verification form has been received.
                    </p>
                   
                    <button type="button" className="tablinks mt-2" onClick={resetForm}>
                        Submit Another Application
                    </button>
                </div>
            ) : (
            <div className="form-content">
                <div className="bg-light p-3 rounded-lg border border-opacity-50 mx-auto p-1">
                    <h2 className="text-center font-bold text-3xl mb-3">
                        CANDIDATE{" "}
                        <span className="text-orange-600">PERSONAL DETAILS</span>
                    </h2>
                    <hr />
                    <div className="row">
                        <div className="col-md-4 col-6">
                            <label htmlFor="name_of_applicant" className="form-label">
                                Name of the Applicant
                            </label>
                            <input
                                type="text"
                                className={`inputtype form-control mb-1${errors.name ? " is-invalid" : ""}`}
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                name="name_of_applicant"
                                required
                            />
                            {errors.name && <div className="text-danger mb-2">{errors.name}</div>}
                        </div>
                        <div className="col-md-4 col-6">
                            <label htmlFor="Input2" className="form-label">
                                Fathers/Husband/Wife Name
                            </label>
                            <input
                                className={`inputtype form-control mb-1${errors.fname ? " is-invalid" : ""}`}
                                list="projects"
                                value={fname}
                                onChange={(e) => setFname(e.target.value)}
                                name="fathers_name"
                                maxLength="100"
                                required
                            />
                            {errors.fname && <div className="text-danger mb-2">{errors.fname}</div>}
                        </div>
                        <div className="col-md-4 col-6">
                            <label htmlFor="Input3" className="form-label">
                                Mother's Name
                            </label>
                            <input
                                type="text"
                                className={`inputtype form-control mb-1${errors.mname ? " is-invalid" : ""}`}
                                value={mname}
                                onChange={(e) => setMname(e.target.value)}
                                name="mothers_name"
                                maxLength="100"
                            />
                            {errors.mname && <div className="text-danger mb-2">{errors.mname}</div>}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-4 col-6">
                            <label htmlFor="Input4" className="form-label">
                                Applicant Gender
                            </label>{" "}
                            <select
                                className={`inputtype form-control mb-1${errors.gender ? " is-invalid" : ""}`}
                                value={gender}
                                onChange={(e) => setGender(e.target.value)}
                                name="gender"
                            >
                                <option value="">choose</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                                <option value="other">other</option>
                            </select>
                            {errors.gender && <div className="text-danger mb-2">{errors.gender}</div>}
                        </div>

                        <div className="col-md-4 input-icons">
                            <label htmlFor="Input5" className="form-label">
                                Date Of Birth
                            </label>

                            <div className="date-container">
                                <input
                                    value={date}
                                    onChange={(e) => setDate(e.target.value)}
                                    type="date"
                                    className={`inputtype form-control mb-1${errors.date ? " is-invalid" : ""}`}
                                    name="dob"
                                />
                            </div>
                            {errors.date && <div className="text-danger mb-2">{errors.date}</div>}
                        </div>

                        <div className="col-md-4 col-6">
                            <label htmlFor="Input6" className="form-label">
                                Email Id
                            </label>{" "}

                            <input
                                type="email"
                                className={`inputtype form-control mb-1${errors.email ? " is-invalid" : ""}`}
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                name="email"
                            />
                            {errors.email && <div className="text-danger mb-2">{errors.email}</div>}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-4 input-icons">
                            <label htmlFor="Input5" className="form-label">
                                Contact Number
                            </label>

                            <div className="date-container">
                                <input
                                    type="number"
                                    className={`inputtype form-control mb-1${errors.number ? " is-invalid" : ""}`}
                                    value={number}
                                    onChange={(e) => setNumber(e.target.value)}
                                    name="contact_number"
                                />
                            </div>
                            {errors.number && <div className="text-danger mb-2">{errors.number}</div>}
                        </div>

                        <div className="col-md-4 col-6">
                            <label htmlFor="Input6" className="form-label">
                                Emergency Contact
                            </label>

                            <input
                                type="number"
                                className={`inputtype form-control mb-1${errors.enumber ? " is-invalid" : ""}`}
                                value={enumber}
                                onChange={(e) => setEnumber(e.target.value)}
                                name="emergency_contact"
                            />
                            {errors.enumber && <div className="text-danger mb-2">{errors.enumber}</div>}
                        </div>

                        <div className="col-md-4 col-6">
                            <label htmlFor="Input7" className="form-label">
                                Company Name
                            </label>

                            <input
                                type="text"
                                className={`inputtype form-control mb-1${errors.companyname ? " is-invalid" : ""}`}
                                value={companyname}
                                onChange={(e) => setCompanyName(e.target.value)}
                                name="name_of_client"
                                maxLength="100"
                            />
                            {errors.companyname && <div className="text-danger mb-2">{errors.companyname}</div>}
                        </div>

                    </div>

                    <div className="row">
                        <div className="col-md-4 col-6">
                            <label htmlFor="Input7" className="form-label">
                                Company Location
                            </label>
                            <input
                                type="text"
                                className={`inputtype form-control mb-1${errors.location ? " is-invalid" : ""}`}
                                value={location}
                                onChange={(e) => setLocation(e.target.value)}
                                name="client_location"
                                maxLength="30"
                            />
                            {errors.location && <div className="text-danger mb-2">{errors.location}</div>}
                        </div>

                        <div className="col-md-4 col-6">
                            <label htmlFor="Input7" className="form-label">
                                Languages Known (optional)
                            </label>
                            <input
                                type="text"
                                className="inputtype form-control mb-3"
                                value={language}
                                onChange={(e) => setLanguage(e.target.value)}
                                name="languages"
                                maxLength="30"
                            />
                        </div>

                        <div className="col-md-4 col-6">
                            <label htmlFor="Input7" className="form-label">
                                Blood Group (optional)
                            </label>
                            <input
                                type="text"
                                className="inputtype form-control mb-3"
                                value={blood}
                                onChange={(e) => setBlood(e.target.value)}
                                name="blood_group"
                                maxLength="5"
                            />
                        </div>
                    </div>

                    <div className="row">
                        <h2>Permanent Address</h2>
                        <div className="col-md-4 col-6">
                            <label htmlFor="Input7" className="form-label">
                                Address Line 1
                            </label>
                            <input
                                type="text"
                                className={`inputtype form-control mb-1${errors.address1 ? " is-invalid" : ""}`}
                                value={address1}
                                onChange={(e) => setAddress1(e.target.value)}
                                name="village_city"
                                maxLength="25"
                            />
                            {errors.address1 && <div className="text-danger mb-2">{errors.address1}</div>}
                        </div>
                        <div className="col-md-4 col-6">
                            <label htmlFor="Input7" className="form-label">
                                Address Line 2 (Optional)
                            </label>
                            <input
                                type="text"
                                className="inputtype form-control mb-3"
                                value={address2}
                                onChange={(e) => setAddress2(e.target.value)}
                                name="village_city2"
                                maxLength="25"
                            />
                        </div>
                        <div className="col-md-4 col-6">
                            <label htmlFor="Input7" className="form-label">
                                Address Line 3 (Optional)
                            </label>
                            <input
                                type="text"
                                className="inputtype form-control mb-3"
                                value={address3}
                                onChange={(e) => setAddress3(e.target.value)}
                                name="village_city3"
                                maxLength="25"
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-4 col-6">
                            <label htmlFor="Input7" className="form-label">
                                Name of Post Office
                            </label>
                            <input
                                type="text"
                                className={`inputtype form-control mb-1${errors.post ? " is-invalid" : ""}`}
                                value={post}
                                onChange={(e) => setPost(e.target.value)}
                                name="post_office"
                                maxLength="100"
                            />
                            {errors.post && <div className="text-danger mb-2">{errors.post}</div>}
                        </div>
                        <div className="col-md-4 col-6">
                            <label htmlFor="Input7" className="form-label">
                                Police Station/Thana
                            </label>
                            <input
                                type="text"
                                className={`inputtype form-control mb-1${errors.police ? " is-invalid" : ""}`}
                                value={police}
                                onChange={(e) => setPolice(e.target.value)}
                                name="police_station"
                                maxLength="100"
                            />
                            {errors.police && <div className="text-danger mb-2">{errors.police}</div>}
                        </div>
                        <div className="col-md-4 col-6">
                            <label htmlFor="Input7" className="form-label">
                                District
                            </label>
                            <input
                                type="text"
                                className={`inputtype form-control mb-1${errors.district ? " is-invalid" : ""}`}
                                value={district}
                                onChange={(e) => setDistrict(e.target.value)}
                                name="district"
                                maxLength="100"
                            />
                            {errors.district && <div className="text-danger mb-2">{errors.district}</div>}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-4 col-6">
                            <label htmlFor="Input7" className="form-label">
                                Tehsil
                            </label>
                            <input
                                type="text"
                                className={`inputtype form-control mb-1${errors.tehsil ? " is-invalid" : ""}`}
                                value={tehsil}
                                onChange={(e) => setTehsil(e.target.value)}
                                name="tehsil"
                                maxLength="100"
                            />
                            {errors.tehsil && <div className="text-danger mb-2">{errors.tehsil}</div>}
                        </div>
                        <div className="col-md-4 col-6">
                            <label htmlFor="Input7" className="form-label">
                                Landmark
                            </label>
                            <input
                                type="text"
                                className={`inputtype form-control mb-1${errors.landmark ? " is-invalid" : ""}`}
                                value={landmark}
                                onChange={(e) => setLandmark(e.target.value)}
                                name="landmark"
                                maxLength="100"
                            />
                            {errors.landmark && <div className="text-danger mb-2">{errors.landmark}</div>}
                        </div>
                        <div className="col-md-4 col-6">
                            <label htmlFor="Input7" className="form-label">
                                Pin Code
                            </label>
                            <input
                                type="number"
                                className={`inputtype form-control mb-1${errors.pincode ? " is-invalid" : ""}`}
                                value={pincode}
                                onChange={(e) => setPincode(e.target.value)}
                                name="pine_code"
                            />
                            {errors.pincode && <div className="text-danger mb-2">{errors.pincode}</div>}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-4 col-6">
                            <label htmlFor="Input7" className="form-label">
                                State
                            </label>
                            <input
                                type="text"
                                className={`inputtype form-control mb-1${errors.state ? " is-invalid" : ""}`}
                                value={state}
                                onChange={(e) => setState(e.target.value)}
                                name="state"
                                maxLength="20"
                            />
                            {errors.state && <div className="text-danger mb-2">{errors.state}</div>}
                        </div>
                    </div>

                    <div className="row mb-4 d-flex flex-row">
                        <label
                            style={{ width: "190px" }}
                            className="form-label"
                            htmlFor="same"
                        >
                            Same as above?
                        </label>
                        <input
                            style={{ width: "30px" }}
                            type="checkbox"
                            id="same"
                            name="same"
                            onChange={() => billingFunction()}
                        />
                    </div>

                    <div className="row">
                        <h2>Current Address</h2>
                        <div className="col-md-4 col-6">
                            <label htmlFor="Input7" className="form-label">
                                Address Line 1
                            </label>
                            <input
                                type="text"
                                className={`inputtype form-control mb-1${errors.address11 ? " is-invalid" : ""}`}
                                value={address11}
                                onChange={(e) => setAddress11(e.target.value)}
                                name="c_village_city"
                                maxLength="25"
                            />
                            {errors.address11 && <div className="text-danger mb-2">{errors.address11}</div>}
                        </div>
                        <div className="col-md-4 col-6">
                            <label htmlFor="Input7" className="form-label">
                                Address Line 2 (Optional)
                            </label>
                            <input
                                type="text"
                                className="inputtype form-control mb-3"
                                value={address22}
                                onChange={(e) => setAddress22(e.target.value)}
                                name="c_village_city2"
                                maxLength="25"
                            />
                        </div>

                        <div className="col-md-4 col-6">
                            <label htmlFor="Input7" className="form-label">
                                Address Line 3 (Optional)
                            </label>
                            <input
                                type="text"
                                className="inputtype form-control mb-3"
                                value={address33}
                                onChange={(e) => setAddress33(e.target.value)}
                                name="c_village_city3"
                                maxLength="25"
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-4 col-6">
                            <label htmlFor="Input7" className="form-label">
                                Name of Post Office
                            </label>
                            <input
                                type="text"
                                className={`inputtype form-control mb-1${errors.post1 ? " is-invalid" : ""}`}
                                value={post1}
                                onChange={(e) => setPost1(e.target.value)}
                                name="c_post_office"
                                maxLength="100"
                            />
                            {errors.post1 && <div className="text-danger mb-2">{errors.post1}</div>}
                        </div>

                        <div className="col-md-4 col-6">
                            <label htmlFor="Input7" className="form-label">
                                Police Station
                            </label>
                            <input
                                type="text"
                                className={`inputtype form-control mb-1${errors.police1 ? " is-invalid" : ""}`}
                                value={police1}
                                onChange={(e) => setPolice1(e.target.value)}
                                name="c_police_station"
                                maxLength="100"
                            />
                            {errors.police1 && <div className="text-danger mb-2">{errors.police1}</div>}
                        </div>

                        <div className="col-md-4 col-6">
                            <label htmlFor="Input7" className="form-label">
                                District
                            </label>
                            <input
                                type="text"
                                className={`inputtype form-control mb-1${errors.district1 ? " is-invalid" : ""}`}
                                value={district1}
                                onChange={(e) => setDistrict1(e.target.value)}
                                name="c_district"
                                maxLength="100"
                            />
                            {errors.district1 && <div className="text-danger mb-2">{errors.district1}</div>}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-4 col-6">
                            <label htmlFor="Input7" className="form-label">
                                Tehsil
                            </label>
                            <input
                                type="text"
                                className={`inputtype form-control mb-1${errors.tehsil1 ? " is-invalid" : ""}`}
                                value={tehsil1}
                                onChange={(e) => setTehsil1(e.target.value)}
                                name="c_tehsil"
                                maxLength="100"
                            />
                            {errors.tehsil1 && <div className="text-danger mb-2">{errors.tehsil1}</div>}
                        </div>

                        <div className="col-md-4 col-6">
                            <label htmlFor="Input7" className="form-label">
                                Landmark
                            </label>
                            <input
                                type="text"
                                className={`inputtype form-control mb-1${errors.landmark1 ? " is-invalid" : ""}`}
                                value={landmark1}
                                onChange={(e) => setLandmark1(e.target.value)}
                                name="c_landmark"
                                maxLength="100"
                            />
                            {errors.landmark1 && <div className="text-danger mb-2">{errors.landmark1}</div>}
                        </div>

                        <div className="col-md-4 col-6">
                            <label htmlFor="Input7" className="form-label">
                                Pin Code
                            </label>
                            <input
                                type="number"
                                className={`inputtype form-control mb-1${errors.pincode1 ? " is-invalid" : ""}`}
                                value={pincode1}
                                onChange={(e) => setPincode1(e.target.value)}
                                name="c_pine_code"
                                maxLength="100"
                            />
                            {errors.pincode1 && <div className="text-danger mb-2">{errors.pincode1}</div>}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-4 col-6">
                            <label htmlFor="Input7" className="form-label">
                                State
                            </label>
                            <input
                                type="text"
                                className={`inputtype form-control mb-1${errors.state1 ? " is-invalid" : ""}`}
                                value={state1}
                                onChange={(e) => setState1(e.target.value)}
                                name="c_state"
                                maxLength="20"
                            />
                            {errors.state1 && <div className="text-danger mb-2">{errors.state1}</div>}
                        </div>
                    </div>

                    <div className="row">
                        <h2>Identity Verification</h2>
                        <div className="col-md-4 col-6">
                            <FileField
                                label="Aadhar Card FRONT SIDE"
                                name="aadhar_front"
                                file={aadhar_front_side}
                                error={errors.aadhar_front_side}
                                onChange={(e) => handleFileChange(e, setAadhar_Front_Side)}
                            />
                        </div>
                        <div className="col-md-4 col-6">
                            <FileField
                                label="Aadhar Card BACK SIDE"
                                name="aadhar_back"
                                file={aadhar_back_side}
                                error={errors.aadhar_back_side}
                                onChange={(e) => handleFileChange(e, setAadhar_Back_Side)}
                            />
                        </div>
                        <div className="col-md-4">
                            <FileField
                                label="Passport Size Photo"
                                name="passport_photo"
                                file={passport_size_photo}
                                error={errors.passport_size_photo}
                                onChange={(e) => handleFileChange(e, setPassport_Size_Photo)}
                            />
                        </div>
                    </div>
                </div>

                <div style={{ overflow: "auto" }}>
                    <div style={{ float: "right" }}>
                        {isLoading && (
                            <img src={img} alt="Loading..." style={{ height: "30px", marginRight: "10px" }} />
                        )}
                        <button
                            type="button"
                            className="tablinks mb-2 ms-2"
                            onClick={handleSubmit}
                            disabled={isLoading || pendingUploads > 0}
                        >
                            Submit
                        </button>
                    </div>
                </div>
            </div>
            )}
        </div>
    );
};
export default BgcForm;
